import React from 'react';

import PropTypes from 'prop-types';

import {
    ToggleChild,
} from 'wanderu-component-toggle';
import { localize } from 'wanderu-i18n';

import Events from './events/TravelModeCarrierEvents';

import styles from './TravelModeCarrier.scss';

const sortCarriersByName = (carrierList, carriers, type) => carrierList.filter(
    (carrierCode) => carriers[carrierCode]
        && carriers[carrierCode][type]
        && carriers[carrierCode][type].name,
)
    .sort((carrierCodeA, carrierCodeB) => {
        const { name: carrierNameA } = carriers[carrierCodeA][type];
        const { name: carrierNameB } = carriers[carrierCodeB][type];
        return carrierNameA.localeCompare(carrierNameB);
    });

function TravelModeContent(props) {
    const {
        carrierCode,
        carriers,
        i18nMoney,
        onOnlyCarrierClick,
        onToggleCarrier,
        t,
        type,
    } = props;

    function handleToggle(select) {
        onToggleCarrier(carrierCode, select);
    }

    function handleClick(e) {
        e.stopPropagation();
        onOnlyCarrierClick(carrierCode);
    }

    const carrierData = carriers[carrierCode];

    const {
        name,
        isActive,
        minPricing,
    } = carrierData[type];

    let totalPrice = null;
    if (minPricing) {
        totalPrice = i18nMoney(minPricing).getTotalPrice();
    }

    return (
        <ToggleChild
            checkboxClassName={styles.carrierCheckbox}
            className={styles.carrierRow}
            isChecked={isActive}
            onChange={handleToggle}
            show
        >
            <span className={styles.carrierName}>
                {name}
            </span>
            <span
                className={styles.onlyButton}
                data-id="onlyButton"
                onClick={handleClick}
                role="button"
            >
                {t('only')}
            </span>
            {totalPrice && (
                <span className={styles.minimumPrice} data-id="minimumPrice">
                    {i18nMoney.format(Math.ceil(totalPrice), {
                        maximumFractionDigits: 0,
                        minimumFractionDigits: 0,
                    })}
                </span>
            )}
        </ToggleChild>
    );
}

TravelModeContent.propTypes = {
    carrierCode: PropTypes.string.isRequired,
    carriers: PropTypes.object.isRequired,
    i18nMoney: PropTypes.func.isRequired,
    onOnlyCarrierClick: PropTypes.func.isRequired,
    onToggleCarrier: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,
};

const LocalizedTravelModeContent = localize(TravelModeContent, ['t', 'i18nMoney'], 'baseApp');

function TravelModeCarrier(props) {
    const {
        carrierList,
        carriers,
        onOnlyCarrierClick,
        onToggleCarrier,
        totalTrips,
        type,
    } = props;

    function handleOnlyCarrierClick(carrierCode) {
        onOnlyCarrierClick(carrierCode, type);
        Events.carrierFilterSelected({
            action: 'click_only',
            carrierCode,
            carriers,
            totalTrips,
            type,
        });
    }

    function handleToggleCarrier(carrierCode, select) {
        onToggleCarrier(carrierCode, type, select);
        Events.carrierFilterSelected({
            action: select
                ? 'select'
                : 'unselect',
            carrierCode,
            carriers,
            totalTrips,
            type,
        });
    }
    const sortedCarrierList = sortCarriersByName(carrierList, carriers, type);
    return sortedCarrierList.map((carrierCode) => {
        return (
            <LocalizedTravelModeContent
                carrierCode={carrierCode}
                carriers={carriers}
                key={carrierCode}
                onOnlyCarrierClick={handleOnlyCarrierClick}
                onToggleCarrier={handleToggleCarrier}
                type={type}
            />
        );
    });
}

TravelModeCarrier.propTypes = {
    carrierList: PropTypes.arrayOf(PropTypes.string).isRequired,
    carriers: PropTypes.object.isRequired,
    onOnlyCarrierClick: PropTypes.func.isRequired,
    onToggleCarrier: PropTypes.func.isRequired,
    totalTrips: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
};

export {
    TravelModeCarrier,
    TravelModeContent,
    sortCarriersByName,
};
export default TravelModeCarrier;
